import { createRouter as _createRouter } from 'vue-router'

export * from 'vue-router'
export { definePage } from 'unplugin-vue-router/runtime'
export {
  DataLoaderPlugin,
  NavigationResult,
} from 'unplugin-vue-router/data-loaders'

export * from 'unplugin-vue-router/data-loaders/basic'


export function createRouter(options) {
  const { extendRoutes, routes } = options
  // use Object.assign for better browser support
  if (extendRoutes) {
    console.warn('"extendRoutes()" is deprecated, please modify the routes directly. See')
  }
  const router = _createRouter(Object.assign(
    options,
    { routes: typeof extendRoutes === 'function' ? (extendRoutes(routes) || routes) : routes },
  ))

  return router
}
